export default (value, separator = '-', parentheses = false) => {
  value = value.replace(/\D/g, '');
  const m = value.match(/^(?:\d{0,1})(\d{3})(\d{3})(\d{4})$/);
  const formattedNum = !parentheses ? m && ['1', ...m.slice(1)].join(separator) : `1 (${m.slice(1, 2)}) ${[...m.slice(2)].join(separator)}`;
  return formattedNum;
};



// WEBPACK FOOTER //
// ./node_modules/cigna-frontend/js/util/formatters.js